/* eslint-disable no-unused-vars */
/**
 * Imports the necessary React components and libraries for rendering a smart table,
 * translating text, displaying cards, empty cells, custom buttons, and breadcrumbs.
 * @module
 * @requires React
 * @requires CSmartTable from "@coreui/react-pro"
 * @requires useTranslation from "react-i18next"
 * @requires Card from "react-bootstrap"
 * @requires EmptyCell from "../../components/emptyCell/emptyCell"
 * @requires CustomButton from "../../components/customButton/customButton"
 * @requires Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb"
 */
import React, { useEffect, useRef, useState } from "react";
import { CSmartTable } from "@coreui/react-pro";
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap";
import { CSVLink } from "react-csv";
import EmptyCell from "../../components/emptyCell/emptyCell";
import CustomButton from "../../components/customButton/customButton";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
// import moment from "moment";
import moment from 'moment-timezone';
import CustomLoadingHTML from "../../components/customLoadingHTML/customLoadingHTML";
import Constant from "../../util/constant";
import CustomeDepotGreyBox from "../../components/customeDepotGreyBox/customeDepotGreyBox";

import Select, { components } from "react-select";
import SearchBar from "../../components/searchBar/searchBar";
import instance from "../../helpers/axios";
import { GET_NOTICE_LIST } from "../../helpers/endPoint";
import { getParams } from "../../helpers/helper.service";

const NoticeManagementNewComponent = (props) => {
  const { t } = useTranslation();

  const {
    checkNoticeData,
    noticeData,
    sorterCallback,
    columns,
    placeHolderShimer,
    noDataTitle,
    noDataDesc,
    clearSearchButton,
    noDataFound,
    exportCsvData,
    noDataAddButtonTitle,
    smarttableref,
    loading,
    tableFilterHeight,
    breadcrumbHeight,
    tabHeaderHeight,
    headerHeight,
    dimensions,
    loaderHtml,
    tableContainerRef,
    itemsPerPage,
    documentDownLoadFun,
    onRowClick,
    createNotice,
    onTableFilterChange,
    searchValue,
    searchFilterClear,
    onFilteredItemsChange,

    noticeList,
    totalCounts,
    totalCountsLoading,
    noticetypemultiarray,
    handleNoticeFilterChange,
    CustomOption,
    noticeTypeFilter,
    onDepotFilteredItemsChange,
    depotTypeFilter,
    dateFilter,
    onSearchValue,
    searchVal,
    searchClearButton,
    handlePageClick,
    handleItemsPerPageChange,
    itemsPerPageOptions,
    getSortIcon,
    handleSort,
    totalPages,
    currentPage,
    pagination,
    customheaderkeys,
    sortOrder,
    startDate,
    endDate,
  } = props;

  const csvHeader = [
    [
      "Title",
      "Sub Title",
      "Notice Type",
      "Depot",
      "Validity",
      "Not Opened",
      "Open",
      "Downloaded",
      "Signed Document",
      "Document Link",
    ],
  ];

  const [exportDataNew, setExportDataNew] = useState([]);
  const [shouldDownload, setShouldDownload] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const csvLinkRef = useRef(null);

  /** Map a single notice item to a CSV row using customheaderkeys */
  const mapItemToCsvRow = (item) => {
    return customheaderkeys.map((i) => {
      if (i === "documenturl" && item[i] == null) {
        return item.noticelink;
      }
      if (item[i] === undefined) {
        return "-";
      }
      if (i === "openedBy") {
        return item?.openedBy?.length;
      }
      if (i === "notOpened") {
        return item.notOpened;
      }
      if (i === "signedBy") {
        return item?.signedBy?.length;
      }
      if (i === "downloadedBy") {
        return item?.downloadedBy?.length;
      }
      if (i === "expirydatetime" && moment(item[i]).isValid()) {
        return moment(item[i]).format("DD-MM-YYYY h:mm A");
      }
      if (Array.isArray(item[i])) {
        return item[i].length > 0 ? item[i].map((intI) => intI[i]).join(", ") : "-";
      }
      if (i === "noticetypename" && item[i] === "") {
        return "-";
      }
      return item[i];
    });
  };

  const handleExportClick = async () => {
    try {
      setLoadingExport(true);

      const EXPORT_PAGE_SIZE = 50;

      let baseParams = { sortOrder: sortOrder, limit: EXPORT_PAGE_SIZE };

      if (searchValue) {
        baseParams.search = searchValue;
      }

      const noticeTypeFilter = localStorage.getItem("noticeTypeFilter");
      const noticeTypeFilterObject = noticeTypeFilter ? JSON.parse(noticeTypeFilter) : null;
      if (noticeTypeFilterObject) {
        baseParams.noticetypeid = noticeTypeFilterObject?.map((i) => i.id);
      }

      const depotFilter = localStorage.getItem("depotFilter");
      const depotFilterObject = depotFilter ? JSON.parse(depotFilter) : null;
      if (depotFilterObject) {
        baseParams.depotid = depotFilterObject?.map((i) => i.id);
      }

      if (startDate && endDate) {
        baseParams.startDate = startDate;
        baseParams.endDate = endDate;
      }

      const firstResponse = await instance.get(
        GET_NOTICE_LIST + "?" + getParams({ ...baseParams, page: 1 })
      );
      const firstData = firstResponse?.data?.data || [];
      const pagination = firstResponse?.data?.pagination || {};
      const totalPages = pagination.totalPages ?? 1;

      let allData = [...firstData];

      for (let page = 2; page <= totalPages; page++) {
        const res = await instance.get(
          GET_NOTICE_LIST + "?" + getParams({ ...baseParams, page })
        );
        const pageData = res?.data?.data || [];
        allData = allData.concat(pageData);
      }

      if (allData.length > 0) {
        const rows = allData.map((item) => mapItemToCsvRow(item));
        setExportDataNew(csvHeader.concat(rows));
        setShouldDownload(true);
      } else {
        alert("No data found to export.");
        setLoadingExport(false);
      }
    } catch (error) {
      console.error("Export error:", error);
      alert("Failed to export data.");
      setLoadingExport(false);
    }
  };

  useEffect(() => {
    if (shouldDownload && exportDataNew.length > 1) {
      csvLinkRef.current.link.click();
      setShouldDownload(false);
      setLoadingExport(false);
    }
  }, [exportDataNew, shouldDownload]);

  useEffect(() => { }, [exportCsvData]);
  useEffect(() => { }, [searchValue]);

  const getDisplayedPages = (currentPage, totalPages) => {
    const maxPagesToShow = 5;
    const halfRange = Math.floor(maxPagesToShow / 2);
 
    let startPage = Math.max(1, currentPage - halfRange);
    let endPage = Math.min(totalPages, currentPage + halfRange);
 
    // Adjust range if less than maxPagesToShow pages are available
    if (endPage - startPage + 1 < maxPagesToShow) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
    }
 
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };
  return (
    <>
      <React.Fragment>
        <div className="page-content dashboard">
          <Breadcrumbs
            breadcrumbInner={false}
            breadcrumbMainTitle={true}
            breadcrumbItem={t("NOTICE_MANAGEMENT")}
          />
          <Card
            className={
              loading
                ? "Main_Card Main_Notice_Management_new LoadingTable"
                : "Main_Card Main_Notice_Management_new"
            }>
            <Card.Body className="p-0 activeTabSupplier">
              <div className="Main_Card_Body">
                <div className="FormButton_Wrapper">
                  <div className="left_div">
                    {/* <SearchBar
                      value={searchVal}
                      placeholder={t("SEARCH_BY_TITLE_SUBTITLE_NOTICE_TYPE")}
                      onChange={(e) => onSearchValue(e.target.value)}
                      onClear={searchClearButton}
                    /> */}

                    <div className="col-sm-auto searchBar">
                      <span
                        className="bx bx-search-alt-2"
                      // onClick={handleSearchClick}
                      >
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        placeholder={t("SEARCH_BY_TITLE_SUBTITLE_NOTICE_TYPE")}
                        value={searchValue ? searchValue : ""}
                        onChange={(e) => onSearchValue(e.target.value)}
                      />
                      {/* {console.log("search", searchValue)} */}
                      {searchValue && (
                        <>
                          <button className="btn-close" onClick={searchClearButton}></button>
                        </>
                      )}
                    </div>

                  </div>
                  <div className="right_div">
                    {noticeData?.length > 0 ? (
                      <>
                        <CustomButton
                          className="black-btn Border_Button"
                          onClick={handleExportClick}
                          disabled={loadingExport}
                        >
                          {loadingExport ? t("EXPORTING...") : t("EXPORT")}
                        </CustomButton>
                        <CSVLink
                          data={exportDataNew}
                          filename={`notices-${moment().format("MM-DD-YYYY")}.csv`}
                          ref={csvLinkRef}
                          className="hidden"
                          target="_blank"
                        />
                      </>
                    ) : (
                      <CustomButton className="black-btn Border_Button disableExport">
                        {t("EXPORT")}
                      </CustomButton>
                    )}

                    <CustomButton
                      color="primary"
                      className="btn-block btn btn-primary Fill_Button"
                      onClick={() => createNotice()}>
                      {t("CREATE_NOTICE")}
                    </CustomButton>
                  </div>
                </div>
                <div className="table-content">
                  <div
                    id="table-scroll"
                    className="table-scroll table-responsive">
                    <table
                      id="main-table"
                      className="main-table  table management-table NoticeMangmentTable">
                      <thead className="tableHeading">
                        <tr>
                          <th className="tableHeader" scope="col">
                            <div className="d-inline sortingWrapper">
                              <div>
                                {t("TITLE")}{" "}
                                <span className="thCount">
                                  {pagination?.total}
                                </span>
                              </div>
                               
                              <span>
                                  <i  className={getSortIcon()} onClick={handleSort}></i>
                                </span>
                            </div>
                          </th>
                          <th className="tableHeader" scope="col">
                            {t("SUB_TITLE")}
                          </th>
                          <th className="tableHeader" scope="col">
                            {t("NOTICE_TYPE")}
                          </th>
                          <th className="tableHeader" scope="col">
                            {t("DEPOT")}
                          </th>
                          <th className="tableHeader" scope="col">
                            {t("VALIDITY")}
                          </th>
                          <th className="tableHeader" scope="col">
                            {t("NOT_OPENED")}
                          </th>
                          <th className="tableHeader" scope="col">
                            <>
                            <div className="d-inline">
                              {t("OPEN_ONLY")} <br />
                              <span className="thCount">
                                {totalCountsLoading ? (
                                  <div className="spinner-border spinner-border-sm text-primary" role="status" style={{ width: '1rem', height: '1rem' }}>
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                ) : (
                                  totalCounts?.openedCount || 0
                                )}
                              </span>
                            </div>
                            </>
                          </th>
                          <th className="tableHeader" scope="col">
                            <>
                            <div className="d-inline">
                              {t("DOWNLOADED")} <br />
                              <span className="thCount">
                                {totalCountsLoading ? (
                                  <div className="spinner-border spinner-border-sm text-primary" role="status" style={{ width: '1rem', height: '1rem' }}>
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                ) : (
                                  totalCounts?.downloadedCount || 0
                                )}
                              </span>
                            </div>
                            </>
                          </th>
                          <th className="tableHeader" scope="col">
                            <>
                            <div className="d-inline">
                              {t("SIGNED_DOCUMENT_TABLE")} <br />
                              <span className="thCount">
                                {totalCountsLoading ? (
                                  <div className="spinner-border spinner-border-sm text-primary" role="status" style={{ width: '1rem', height: '1rem' }}>
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                ) : (
                                  totalCounts?.signedCount || 0
                                )}
                              </span>
                            </div>
                            </>
                          </th>
                          <th className="tableHeader" scope="col">
                            <>{t("STATUS")}</>
                          </th>
                          <th className="tableHeader" scope="col">
                            <>{t("DOCUMENT_LINK")}</>
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          <th >
                            {noticeTypeFilter(noticeList, onFilteredItemsChange)}
                          </th>
                          <th>
                            {depotTypeFilter(noticeList, onDepotFilteredItemsChange)}
                          </th>
                          <th>
                            {dateFilter()}
                          </th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody
                      ref={tableContainerRef}

                      style={{
                        height:
                          dimensions.height -
                          headerHeight -
                          breadcrumbHeight -
                          tableFilterHeight -
                          tabHeaderHeight - 
                          150,
                        overflow: "auto",
                      }}
                      className="Table-Body-scroll"
                      >
                        {noticeData?.length > 0 ? (
                          <>
                            {noticeData.map((item, index) => {
                              const shortname = item?.ownerDetails?.name
                                ? (() => {
                                  const nameComponents =
                                    item?.ownerDetails?.name
                                      ?.trim()
                                      ?.split(" ");

                                  if (nameComponents?.length === 1) {
                                    return nameComponents[0][0].toUpperCase();
                                  } else if (nameComponents?.length === 2) {
                                    return (
                                      nameComponents[0][0] +
                                      nameComponents[1][0]
                                    ).toUpperCase();
                                  } else if (nameComponents?.length >= 3) {
                                    return nameComponents[0]
                                      .substring(0, 2)
                                      .toUpperCase();
                                  }

                                  return "-";
                                })()
                                : "-";

                              // const isDisabled = inRecommandedOrg?.length >= 3 && !item?.isRecommanded;
                              const className =
                                item?.status === Constant.GENERALKEYS.INACTIVE
                                  ? "disabled"
                                  : "";
                              return (
                                  <tr key={`tr${index}`} onClick={(e) => { onRowClick(item)}}>
                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <p className='wordBrake'>
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.title}
                                      </p>
                                    </td>

                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <p className='wordBrake'>
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.subtitle || "-"}
                                      </p>
                                    </td>

                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <p className='wordBrake'>
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.noticetypename[0]?.noticetypename || "-"}
                                      </p>
                                    </td>
                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <p className="counte-depot">
                                        {placeHolderShimer && <CustomeShimer />}

                                        {item?.depotname
                                          ?.slice(0, 2)
                                          .map((value, index) => {
                                            return (
                                              <CustomeDepotGreyBox
                                                key={`depot-${index}-${value?.depotname}`}
                                                className={`${value?.depotname.length >= 20 && !value?.depotname.includes(' ')
                                                  ? 'breakeAll'
                                                  : 'wordBrake'
                                                  }`}
                                                depotname={value?.depotname}
                                              />
                                            );
                                          })}
                                        {item?.depotname?.length > 2 && (
                                          <CustomeDepotGreyBox
                                            title={item?.depotname
                                              ?.slice(2)
                                              .map((valueTilte, valueindex) => {
                                                return valueTilte.depotname;
                                              })}
                                            plusShow={true}
                                            className={`${item?.depotname.length >= 20 && !item?.depotname.includes(' ')
                                              ? 'breakeAll'
                                              : 'wordBrake'
                                              }`}
                                            depotname={item?.depotname?.length - 2}
                                          />
                                        )}
                                      </p>
                                    </td>
                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <div className="depot-Wrapper">
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.noticestatus === 'Active' ? moment.utc(item.expirydatetime).tz('Europe/London').format('DD-MM-YYYY h:mm A') : item?.noticestatus}
                                      </div>
                                    </td>

                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <div className="depot-Wrapper">
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.notOpened}
                                      </div>
                                    </td>

                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <div className="depot-Wrapper">
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.openedBy?.length || 0}
                                      </div>
                                    </td>
                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <div className="depot-Wrapper">
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.downloadedBy?.length || 0}
                                      </div>
                                    </td>

                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <div className="depot-Wrapper">
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.signedBy?.length || 0}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="status_wrapper">
                                        <span>{t("NOT_OPENED")}</span> <span>: {item?.notOpened}</span>
                                      </div>
                                      <div className="status_wrapper">
                                        <span>{t("OPEN_ONLY")}</span> <span>: {item?.openedBy?.length}</span>
                                      </div>
                                      <div className="status_wrapper">
                                        <span>{t("DOWNLOADED")}</span> <span>: {item?.downloadedBy?.length}</span>
                                      </div>
                                      <div className="status_wrapper">
                                        <span>{t("SIGNED")}</span> <span>: {item?.signedBy?.length}</span>
                                      </div>
                                      
                                      
                                    </td>
                                    <td
                                      className={
                                        item?.noticestatus ===
                                        Constant.GENERALKEYS.INACTIVE ? "disableTd" : undefined
                                      }
                                    >
                                      <div className="Document_btn_wrapper">
                                        {placeHolderShimer && <CustomeShimer />}
                                        {item?.noticelink
                                          ? item?.noticelink && (
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                window.open(item?.noticelink);
                                              }}
                                              className="document_button"
                                            >
                                              <i className="bx bx-show"></i>
                                            </button>
                                          )
                                          : item?.documenturl && (
                                            <button
                                              onClick={(event) => {
                                                event.stopPropagation();
                                                documentDownLoadFun(item);
                                              }}
                                              className="document_button"
                                            >
                                              <i className="dripicons-arrow-thin-down"></i>
                                            </button>
                                          )}
                                      </div>
                                    </td>
                                  </tr>
                              );
                            })}
                          </>
                        ) : (
                          <>
                            {!placeHolderShimer && (
                              <tr className="emptyRow">
                                <td colSpan={10}>
                                  <EmptyCell
                                    emptyItems={noticeData}
                                    noDataTitle={
                                      noticeData?.length === 0
                                        ? noDataFound
                                        : noDataTitle
                                    }
                                    noDataAddButton={true}
                                    noDataAddButtonTitle={noDataAddButtonTitle}
                                    noDataDesc={noDataDesc}
                                    clearButton={
                                      searchValue?.length === undefined ||
                                        searchValue?.length === 0
                                        ? false
                                        : true
                                    }
                                    clearSearchButton={searchClearButton}
                                    // clearSearchButton={clearSearchButton}
                                  />
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                    {noticeData?.length > 0 && (
                      <>
                      <div className="paginationDiv mt-4">
                      <nav aria-label="Page navigation">
                        <ul className="pagination">
                          {/* Previous Button */}
                          <li
                            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                              className="page-link placeholder-glow"
                              onClick={() => handlePageClick(currentPage > 0 ? currentPage - 1 : 1)}>
                              <i className="bx bx-chevron-left" />
                            </button>
                          </li>
                          {/* <li className={`page-item active`}>
                            <button
                              className="page-link placeholder-glow"
                              onClick={() => handlePageClick()}>
                              1
                            </button>
                          </li>
                          <li className={`page-item`}>
                            <button
                              className="page-link placeholder-glow"
                              onClick={() => handlePageClick()}>
                              2
                            </button>
                          </li> */}
                          {/* {console.log("current page", currentPage)} */}
                            {/* {console.log("totalPages", totalPages)} */}
                            {/* {Array.from({ length: totalPages }, (_, index) => (
                              <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                <button
                                  className="page-link placeholder-glow"
                                  onClick={() => handlePageClick(index + 1)}>
                                  {index + 1}
                                </button>
                              </li>
                            ))} */}
                    {getDisplayedPages(currentPage, totalPages)?.map((page) => (
                      <li
                        key={page}
                        className={`page-item ${currentPage === page ? "active" : ""}`}
                      >
                        <button
                          className="page-link placeholder-glow"
                          onClick={() => handlePageClick(page)}
                        >
                           {page}
                        </button>
                      </li>
                    ))}
                          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                              className="page-link placeholder-glow"
                              onClick={() => handlePageClick(currentPage < totalPages ? currentPage + 1 : totalPages)}>
                              <i className="bx bx-chevron-right" />
                            </button>
                          </li>
                        </ul>
    
                        <div className="items-per-page-dropdown placeholder-glow">
                          <select
                            className="form-select"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}>
                            {itemsPerPageOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}/ {t("Page")}
                              </option>
                            ))}
                          </select>
                        </div>
                      </nav>
                    </div>
                  </>                    
                    )}
                  </div>
                </div>
                    
                {placeHolderShimer && <CustomLoadingHTML />}
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>
    </>
  );
};

export default NoticeManagementNewComponent;
